import { render, staticRenderFns } from "./Unlock.vue?vue&type=template&id=bffd7bfe&scoped=true&"
import script from "./Unlock.vue?vue&type=script&lang=js&"
export * from "./Unlock.vue?vue&type=script&lang=js&"
import style0 from "./Unlock.vue?vue&type=style&index=0&id=bffd7bfe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffd7bfe",
  null
  
)

export default component.exports